import { render, staticRenderFns } from "./TextareaField.vue?vue&type=template&id=2ed93d72&scoped=true&"
import script from "./TextareaField.vue?vue&type=script&lang=js&"
export * from "./TextareaField.vue?vue&type=script&lang=js&"
import style0 from "./TextareaField.vue?vue&type=style&index=0&id=2ed93d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed93d72",
  null
  
)

export default component.exports